import { render } from "./admin-statistic.vue?vue&type=template&id=3bcd1f30&scoped=true&ts=true"
import script from "./admin-statistic.vue?vue&type=script&lang=ts"
export * from "./admin-statistic.vue?vue&type=script&lang=ts"

import "./admin-statistic.vue?vue&type=style&index=0&id=3bcd1f30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcd1f30"]])

export default __exports__